// extracted by mini-css-extract-plugin
export var blue = "_4b-h";
export var brand = "_4b-d";
export var darkGrey = "_4b-g";
export var disabled = "_4b-6";
export var disabledSubtle = "_4b-7";
export var error = "_4b-8";
export var green = "_4b-i";
export var grey = "_4b-f";
export var icon = "_4b-0";
export var inherit = "_4b-c";
export var lightGrey = "_4b-e";
export var orange = "_4b-k";
export var pink = "_4b-m";
export var primary = "_4b-1";
export var purple = "_4b-n";
export var quaternary = "_4b-4";
export var quinary = "_4b-5";
export var red = "_4b-l";
export var secondary = "_4b-2";
export var success = "_4b-b";
export var tertiary = "_4b-3";
export var warning = "_4b-9";
export var warningSecondary = "_4b-a";
export var white = "_4b-o";
export var yellow = "_4b-j";